import { useTranslation } from 'react-i18next';
import { getHistoryLegacyTranslations, useRecapTranslationsQuery } from '../../../services/HistoryPageServices';
import { HistoryLegacyCard, LegacyCarouselDotType, LegacyCarouselType } from '../../../types/Cards/HistoryLegacyCardType';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import rightArrowImg from '../../../assets/images/icon/forward.svg';
import carouselArrowImg from '../../../assets/images/icon/carouselbutton.svg';
import { Container } from 'react-bootstrap';

function HistoryLegacy() {
  const { t } = useTranslation('recap_legacy');
  const recapQuery = useRecapTranslationsQuery();
  const legacyTrans = recapQuery.data ? getHistoryLegacyTranslations(recapQuery.data) : undefined;
  const isLoading = recapQuery.isLoading;

  if (!legacyTrans || isLoading) return null;
  return(
    <section className='history-legacy'>
      <Container className='history-legacy__container'>
        <div>
          <div className='history-legacy__heading'>{t('legacy_section_name')}</div>
          <div className='history-legacy__title'>{t('legacy_title')}</div>
        </div>
        {legacyTrans && <LegacyCarousel legacyTrans={legacyTrans} />}
      </Container>
    </section>
  );
}

function LegacyCarousel({legacyTrans}: LegacyCarouselType) {
  const { t } = useTranslation('recap_legacy');
  const cardsPerSlide = 4;
  const responsive = {
    desktop: {
      breakpoint: { max: Infinity,
        min: 1024 },
      items: cardsPerSlide,
      slidesToSlide: cardsPerSlide
    }
  };
  const extraCardCount = (cardsPerSlide - legacyTrans.length % cardsPerSlide) % cardsPerSlide;
  const extraCards = Array.from({ length: extraCardCount }, (_, index) => index);
  return (
    <div>
      <div className='history-legacy__carousel__wrapper'>
        <Carousel
          responsive={responsive}
          containerClass="history-legacy__carousel"
          showDots={true}
          customDot={<LegacyCarouselDot onClick={function (index: number): void { return; } } index={0} active={false} />}
          dotListClass="history-legacy__dot-container"
          partialVisible={true}
          renderButtonGroupOutside={true}
          customButtonGroup={<ButtonGroup legacyTrans={legacyTrans}/>}
          draggable={false}
          arrows={false}
        >
          {legacyTrans?.map((value, index) => {
            const card = {
              image: t(`legacy_card_image_${index}`),
              title: t(`legacy_card_title_${index}`),
              link: t(`legacy_card_link_${index}`),
              imageAltText: t(`legacy_card_image_alt_text_${index}`),
            };
            return (
              <LegacyCard key={index} card={card} index={index} priority={index < 2}/>
            );
          })}
          {extraCards.map((_, index) => {
            return(<div key={`history_legacy_placeholder_${index}`} style={{width: '0'}}></div>);
          })}
        </Carousel>
      </div>
      <div className='history-legacy__freescroll'>
        {legacyTrans?.map((value, index) => {
          const card = {
            image: t(`legacy_card_image_${index}`),
            title: t(`legacy_card_title_${index}`),
            link: t(`legacy_card_link_${index}`),
            imageAltText: t(`legacy_card_image_alt_text_${index}`),
          };
          return (
            <LegacyCard key={index} card={card} index={index} priority={index === 0}/>
          );
        })}
      </div>
    </div>
  );
  function ButtonGroup({ next, previous, goToSlide, ...rest }: any) {
    const { carouselState: { currentSlide } } = rest;
    const lastSlide = Math.max(legacyTrans.length + extraCards.length - cardsPerSlide, 0);
    const isFirstSlide = currentSlide === 0;
    const isLastSlide = currentSlide >= lastSlide;
    return (
      <div className='history-legacy__button-group'>
        <div className={`history-legacy__arrow history-legacy__arrow--left ${!isFirstSlide ? 'history-legacy__arrow--active': ''}`} onClick={!isFirstSlide ? previous : undefined}>
          <img src={rightArrowImg} className='history-legacy__arrow__icon history-legacy__arrow__icon-left' alt='right arrow'/>
        </div>
        <div className={`history-legacy__arrow history-legacy__arrow--right ${!isLastSlide ? 'history-legacy__arrow--active': ''}`} onClick={!isLastSlide ? next : undefined}>
          <img src={rightArrowImg} className='history-legacy__arrow__icon' alt='right arrow' />
        </div>
      </div>
    );
  }

  function LegacyCarouselDot({ onClick, index, active }: LegacyCarouselDotType) {
    return (
      <div
        className={`history-legacy__dot ${active ? 'history-legacy__dot--active' : ''}`}
      />
    );
  }
}

function LegacyCard({ card, index, priority = false }:  HistoryLegacyCard & { priority?: boolean }) {
  return (
    <div className='history-legacy-card__wrapper'>
      <img
        src={card.image}
        className='history-legacy-card__img'
        alt={card.imageAltText}
        loading={priority ? 'eager' : 'lazy'}
        decoding='async'
        fetchPriority={priority ? 'high' : 'auto'}
      />
      <div className='history-legacy-card__shadow-overlay'></div>
      <a className='history-legacy-card__title' href={card.link}>
        <div className='history-legacy-card__title__text'>
          {card.title}
          <img src={carouselArrowImg} className='history-legacy-card__title__img' alt="legacy card"/>
        </div>
      </a>
    </div>
  );
}

export default HistoryLegacy;
